import { Column, ColumnEditorOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter } from "./Filter";
import { GenerateBranchIncentiveList } from "./GenerateBranchIncentiveList";
import { ILogin } from "../../models/Login";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    toast: any;
}

export const GenerateBranchInvoiceTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const [openIncentiveList, setOpenIncentiveList] = useState({ open: false, singleData: {}, type: "", diff: 0 } as { open: boolean, singleData: any, type: string, diff: number });
    const [openPaymentChangeConfrimModal, setOpenPaymentChangeConfrimModal] = useState({ open: false, singleData: {} } as { open: boolean, singleData: any });
    const [incentiveFilter, setIncentiveFilter] = useState<any>({
        month: new Date(),
        company: null,
        branch: null,
    });
    const [loading, setLoading] = useState<boolean>(false);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    const header = () => {
        return (
            <>
            </>
        );
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/getBranchIncentiveInvoiceConsultantWise", "GET", null, `filter=${encodeURIComponent(JSON.stringify(incentiveFilter))}`, props.toast);
        if (response) {
            const data: any[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    };

    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    const updateRow = async (data: any) => {
        setLoading(true);
        let body = {
            id: data.id,
            payment_Status: ((data.payment_Received_Amount < data.total_Invoice_Amount) ? "Balance" : ((data.payment_Received_Amount > data.total_Invoice_Amount) ? "Over Payment" : "Paid")),
            payment_Received_Amount: Number(data.payment_Received_Amount),
            is_Payment_Received: true,
        };

        const response = await Fetch("InvoiceTracking/updateBranchInvoiceConsultantWise", "PUT", body, null, toast);
        if (response) {
            const data1: any = await response.json();
            setLoading(false);
            setOpenPaymentChangeConfrimModal({ open: false, singleData: {} });
            if (data1 && data1 !== null && data1 !== undefined && data1?.openConsultantList && data1?.openConsultantList === true) {
                setOpenIncentiveList({ open: true, singleData: data, type: data1?.type, diff: data1?.diff });
            } else {
                toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Recivend Amount Updated Successfully' });
                loadTableData();
            }
            return true;
        } else {
            setLoading(false);
            setOpenPaymentChangeConfrimModal({ open: false, singleData: {} });
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to Updated Recivend Amount' });
            return false;
        }
    }

    const onApprove = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        if ((rowData.is_Payment_Received === false || rowData.is_Payment_Received === null) || (_roles.includes(1) || _roles.includes(11))) {
            switch (field) {
                case 'quantity':
                case 'payment_Received_Amount':
                    if (isPositiveInteger(newValue)) rowData[field] = newValue;
                    else event.preventDefault();
                    break;

                default:
                    if (newValue.trim().length > 0) rowData[field] = newValue;
                    else event.preventDefault();
                    break;
            };

            let updateData: any = rowData;
            updateData.payment_Received_Amount = newValue;
            if (await updateRow(updateData)) {
                setTableData(prev => {
                    const updatedData = prev.tableData.map(item => {
                        if (item.id === rowData.id) {
                            return { ...item, payment_Received_Date: new Date(), payment_Received_Amount: newValue, paymentStatus: ((rowData.payment_Received_Amount < rowData.total_Invoice_Amount) ? "Balance" : ((rowData.payment_Received_Amount > rowData.total_Invoice_Amount) ? "Over Payment" : "Paid")) };
                        }
                        return item;
                    });
                    return { ...prev, tableData: updatedData };
                })
            };
        } else toast.current.show({ severity: 'error', content: "Can not update once Payment is updated. Please contact Admin or Respective Branch Head" });

    }

    const onCellEditComplete = async (e: any) => {
        setOpenPaymentChangeConfrimModal({ open: true, singleData: e });
    };

    const cellEditor = (options: ColumnEditorOptions) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (options.editorCallback) {
                options.editorCallback(e.target.value);
            }
        };

        return <input style={{ width: '100%', margin: 0, padding: '3px 5px', border: '2px solid green', outline: 'none', cursor: "pointer" }} value={options.value} type='number' onChange={(e) => handleChange(e)} />
    };

    const onHide = () => {
        setOpenIncentiveList({ open: false, singleData: {}, type: "", diff: 0 });
        loadTableData();
    }

    useEffect(() => {
        loadTableData();
    }, [incentiveFilter]);

    const DateFormat = loginObj.date_Format;
    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter incentiveFilter={incentiveFilter} setIncentiveFilter={setIncentiveFilter} toast={props.toast} generated={true} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                dataKey="id"
                value={tableData.tableData}
                emptyMessage="No Branches found."
                header={header}
                loading={tableData.loading}
                paginator
                rows={100}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
            >
                <Column field="sn" header="SN" style={{ minWidth: '3rem', maxWidth: '3rem' }} body={(rowData, options) => options.rowIndex + 1} />
                <Column field="company_Name" header="Company Name" />
                <Column field="branchName" header="Branch" />
                <Column field="invoice_Date" header="Month - Year" body={(rowData: any) => rowData?.invoice_Date ? <p>{new Date(rowData?.invoice_Date || "").toLocaleString("default", { month: "long" })} - {new Date(rowData?.invoice_Date || "").getFullYear()}</p> : <p></p>} />
                <Column field="total_Invoice_Amount" header="Total Invoice Amount $" body={(rowData) => <p className="cursor-pointer text-cyan-700 underline" onClick={() => setOpenIncentiveList({ open: true, singleData: rowData, type: "", diff: 0 })}>{rowData.total_Invoice_Amount}</p>} />
                <Column field="payment_Received_Amount" header="Payment Received Amount $" editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="pending_Amount" header="Pending Amount $" />
                <Column field="payment_Status" header="Payment Status" body={(rowData: any) => <p>{rowData.payment_Status === null ? "Pending" : rowData.payment_Status}</p>} />
                {/* <Column field="payment_Received_Date" header="Payment Received Date" body={(rowData: any) => {
                    let date;
                    if (rowData.payment_Received_Date) date = format(new Date(rowData.payment_Received_Date), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} /> */}
                <Column field="payment_Received_Date" header="Payment Received Date" body={(rowData: any) => safeFormatDate(rowData.payment_Received_Date, 'dd/MM/yyyy', DateFormat)} />
            </DataTable>
            <GenerateBranchIncentiveList open={openIncentiveList.open} singleData={openIncentiveList.singleData} type={openIncentiveList.type || ""} diff={openIncentiveList.diff || 0} toast={toast} onClose={onHide} />
            <Dialog visible={openPaymentChangeConfrimModal.open} style={{ width: '42vw' }} header="Confrimation" modal className="p-fluid" onHide={() => setOpenPaymentChangeConfrimModal({ open: false, singleData: {} })}>
                <div style={{ padding: "35px" }} className="flex align-items-center gap-3">
                    <span className="pi pi-exclamation-triangle" style={{ fontSize: "24px" }}></span> Are You Sure You Want To Change Payemt Received Amount.
                </div>
                <form className="p-fluid formgrid grid mt-3">
                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button style={{ width: '100px', background: "white", color: "#2196F3" }} label="No" onClick={() => setOpenPaymentChangeConfrimModal({ open: false, singleData: {} })} loading={loading} disabled={loading} type="button"></Button>
                        <Button style={{ width: '100px' }} label="Yes" onClick={() => onApprove(openPaymentChangeConfrimModal.singleData)} loading={loading} disabled={loading} type="button"></Button>
                    </div>
                </form>
            </Dialog>
            <Toast ref={toast} />
        </>
    );
}